import $ from 'jquery';

import Section from "../Section";
import Pagination from '../global/Pagination';
import Parallax from '../global/Parallax';
import QuickAdd from '../global/QuickAdd';

export default class CollectionSection extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.element = element;
    this.theme = theme;

    this.loadTagFilter();
    this.loadSortBy();

    this.initPagination();
    this.loadShopNow();
    this.loadQuickAdd();
    this.handleProductCardDisplay();
    this.initParallax();

    this.theme.addBadges(this.element, 1000);

    document.addEventListener('shopify:section:load', () => {
      this.handleProductCardDisplay();
      this.initParallax();
    });

    document.addEventListener('paginate', this.initPagination);
    document.addEventListener('shopify:section:select', this.initParallax);
    document.addEventListener('shopify:section:deselect', this.initParallax);
    document.addEventListener('shopify:section:reorder', this.initParallax);
    window.addEventListener('resize', this.handleProductCardDisplay);
  }

  initParallax = () => {
    // collection image is outside of main div, need to call it on parent
    this.parallax = new Parallax(this.theme, this.element.parentNode);
  }

  initPagination = () => {
    this.pagination = new Pagination(this.theme, this.element, this.loadShopNow, this.loadQuickAdd);
  }

  handleProductCardDisplay = () => {
    const gridViewItems = this.element.querySelectorAll('.grid-view-item');

    gridViewItems.forEach((gridViewItem) => {
      const isMobile = this.isMobile();
      const gridItemWidth = gridViewItem.offsetWidth;
      
      // Quick shop display
      const quickAddContainer = gridViewItem.querySelector('.product-card-image--bottom-wrapper');
      const quickAddWrapper = gridViewItem.querySelector('.quick-add-wrapper');
      if (quickAddContainer && quickAddWrapper) {
        if (gridItemWidth < 250 && !isMobile) {
          quickAddContainer.classList.add('quick-add-container--small');
          quickAddWrapper.classList.add('quick-add-wrapper--small');
        } else if (gridItemWidth > 250 || isMobile) {
          quickAddContainer.classList.remove('quick-add-container--small');
          quickAddWrapper.classList.remove('quick-add-wrapper--small');
        }
      }
      
      // Small grid item width layout toggle
      if (gridItemWidth < 250) {
        gridViewItem.classList.add('grid-view-item--small');
      } else {
        gridViewItem.classList.remove('grid-view-item--small');
      }
    });
  }

  loadShopNow = () => {
    Array.prototype.forEach.call(
      this.element.querySelectorAll('.shop-now-button, .quick-add-button-variants'),
      (el) => {
        el.removeEventListener('click', this.handleShopNow);
        el.addEventListener('click', this.handleShopNow);
      },
    );
    this.theme.addBadges(this.element, 1000);
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }

  loadTagFilter = () => {
    /* Product Tag Filters - Good for any number of filters on any type of collection pages */
    var collFilters = $('.coll-filter');
    collFilters.on('change', function () {
      var newTags = [];
      var val = $(this).val();
      if (val) {
        newTags.push(val);
      }
      if (newTags.length) {
        var query = newTags.join('+');
        var link = $('#link-to-tag-generic a').attr('href').replace(/\+/g, '%20');
        window.location.href = link.replace(/(\/|=)tag($|\?|&)/, '$1' + query + '$2');
      } else {
        window.location.href = $('#link-to-collection').val().toString();
      }
    });
    $('.collection-filter-tag-checkbox').on('change', function () {
      var filter = Array.prototype.map.call(
        document.querySelectorAll('input.collection-filter-tag-checkbox:checked'),
        function (el) { return el.value; }
      ).join('+');
      var link = $('#link-to-tag-generic a').attr('href').replace(/\+/g, '%20');
      window.location.href = link.replace(/(\/|=)tag($|\?|&)/, '$1' + filter + '$2');
    });
  }

  loadSortBy = () => {
    const queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    $('.coll-sort-by')
      .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}');

    $('.coll-sort-by,.collection-sort-by-radio')
      .on('change', function() {
        queryParams.sort_by = $(this).val();
        location.search = $.param(queryParams).replace(/\+/g, '%20');
      });
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.currentTarget.href });
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
